import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import {LockIcon} from '@primer/octicons-react'

import {LABELS} from '../constants/labels'
import {getLockString} from '../utils/get-lock-string'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {LockedEventNode} from './issue-viewer-view-query-types'
import {TimelineRow} from './row/TimelineRow'

// RELAY-CLEANUP(LockedEvent): widens nullable fields so still-Relay parent data is assignable.
// Remove when IssueTimelineItem leaves Relay.
export type LockedEventFragment = RelayCompat<
  Pick<LockedEventNode, 'actor' | 'createdAt' | 'databaseId' | 'lockReason'>
>

type LockedEventProps = {
  queryRef: LockedEventFragment
  issueUrl: string
  onLinkClick?: (event: MouseEvent) => void
  highlightedEventId?: string
  refAttribute?: React.RefObject<HTMLLIElement | null>
}

export function LockedEvent({
  queryRef,
  issueUrl,
  onLinkClick,
  highlightedEventId,
  refAttribute,
}: LockedEventProps): React.ReactElement {
  const {actor, createdAt, lockReason, databaseId} = queryRef
  const lockReasonString = getLockString(lockReason)
  const highlighted = String(databaseId) === highlightedEventId

  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      onLinkClick={onLinkClick}
      createdAt={createdAt}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
      leadingIcon={LockIcon}
    >
      <TimelineRow.Main>
        {`${LABELS.timeline.locked} `}
        {lockReason && <>{`${LABELS.timeline.as} ${lockReasonString} `}</>}
        {`${LABELS.timeline.limitedToCollaborators} `}
      </TimelineRow.Main>
    </TimelineRow>
  )
}
